import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { AddressAssetModel } from '@ibexfusion/models/common/models/api-models/address-asset.model';
import { Models } from '@ibexfusion/models';
import { MessengerService } from '@services/messenger/messenger.service';
import { ContactAndAddressService } from '@services/contact-and-address/contact-and-address.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';

@Component({
    selector: 'app-contact-and-address-edit',
    templateUrl: './contact-and-address-edit.component.html',
    styleUrls: ['./contact-and-address-edit.component.scss'],
    providers: [ContactAndAddressService],
    standalone: false
})
export class ContactAndAddressEditComponent implements OnInit {
  type;
  itemId;
  public pageActions: PageAction[] = [];
  content: AddressAssetModel = new Models.AddressAssetModel();

  constructor(private activatedRoute: ActivatedRoute, private router: Router,
              private ms: MessengerService, private contactAndAddressService: ContactAndAddressService,
              private snackbar: SnackbarService) {
    this.type = this.activatedRoute.snapshot.params['type'];
    this.itemId = this.activatedRoute.snapshot.params['itemId'];
  }

  ngOnInit() {
    this.createPageAction();
    this.content.coordinates = {
      latitude: '',
      longitude: ''
    };
    if (this.itemId) {
      this.getItem();
    }
  }

  getItem() {
    this.contactAndAddressService.get(this.itemId).then((res) => {
      if (res) {
        this.content = res;
      }
    });
  }

  createPageAction() {
    this.pageActions.push(
      new PageAction({
        icon: 'subdirectory_arrow_left', title: 'Back', translationString: 'general.back',
        callback: () => { this.backPage() }
      }),
      new PageAction({
        icon: 'save', id: 'save', title: 'Save', translationString: 'general.save',
        callback: () => { this.save() }
      })
    );
  }

  async backPage() {
    this.router.navigate(['contact'], { queryParams: {tab: this.type} });
  }

  save() {
    if (this.content.title) {
      if (!this.content._id) {
        this.content.type = this.type;
        this.content.OwnerOrganisationID = this.ms.getOrganisation().OrganisationID.toString();
        this.content.OwnerProfileID = this.ms.$activeProfile.getValue().ProfileID;
        this.contactAndAddressService.create(this.content).then(res => {
          this.snackbar.success('Saved changes successfull');
        });
      } else {
        this.contactAndAddressService.update(this.content._id, this.content).then(res => {
          this.snackbar.success('Saved changes successfull');
        });
      }
    }
  }
}
